import { isFeatureEnabled } from '../config/feature-flags';

const ALL_OPTIONS = [
  { label: 'Millions', value: 'Millions' },
  { label: 'Thousands', value: 'Thousands' },
  { label: 'Billions', value: 'Billions' },
] as const;

// This SCALE_CONFIG condition is added to accepting feature flag for "Billions" Options
// Currently only show "Millions" and "Thousands" in prod
export const SCALE_CONFIG = {
  DEFAULT: 'Millions',
  get OPTIONS() {
    return isFeatureEnabled('SCALE_BILLIONS')
      ? ALL_OPTIONS
      : ALL_OPTIONS.slice(0, 2);
  },
} as const;

export type ScaleValue = (typeof ALL_OPTIONS)[number]['value'];
